import { FC } from "react"
import { OnboardingFollows } from "../Components/OnboardingFollows"

export const OnboardingFollowArtists: FC = () => {
  return <OnboardingFollows kind="artists" />
}
